module.exports = __webpack_public_path__ + "img/item-price-library-active.2578dcbe.png";